<div class="form-modal">
  <div class="form-modal__body">

	<a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
		aria-label="Close organization edit form">
		<img src="./assets/img/icons-svg/close-icon.svg">
	</a>
	<div class="img-wrapper">
		<div class="clearfix"></div>
		<div class="title-wrapper">
			<h1>Create user</h1>
		</div>
	</div>
	<popup-loader *ngIf="!isloaded"></popup-loader>
    <div class="form-wrapper" *ngIf="isloaded">
		<form novalidate [formGroup]="userCreateForm" (ngSubmit)="doSave()">
			<div class="app-c-form-group">
				<label class="app-c-form--label" for="fullName">Full Name</label>
				<input class="app-c-form-control" type="text" formControlName="fullName" id="fullName" />
				<div class="error-message" *ngIf="f.fullName.touched && f.fullName.errors?.required">
					Fullname is required
				</div>
			</div>

			<div class="app-c-form-group">
				<label class="app-c-form--label" for="email">Email</label>
				<input class="app-c-form-control" type="text" formControlName="email" id="email" />
				<div class="error-message" *ngIf="f.email.touched && !f.email.valid">
					Invalid email
				</div>
			</div>
			<p>Use comma delimited list if creating multiples.</p>

			<div class="app-c-form-group">
				<label class="app-c-form--label" for="status" translate>Status</label>
				<select class="app-c-form-control" id="status" formControlName="status">
					<option value="approved">Approved</option>
					<option value="disabled">Disabled</option>
				</select>
			</div>

			<div class="app-c-form-group">
				<label class="app-c-form--label" for="password" translate>Password</label>
				<div class="icon-input password-input">
					<input
						class="app-c-form-control"
						id="password"
						tabindex="0"
						aria-label="Password"
						type="{{passwordType}}"
						formControlName="password"
						(ngModelChange)="onChangePassword()" />
					<i class="icon-password-eye" (click)="onClickPassword()" style="cursor: pointer;"
						[ngClass]="passwordType == 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
				</div>
				<div class="error-message" *ngIf="f.password.touched && !f.password.valid">
					Invalid password
				</div>
			</div>

			<div class="form-field">
				<label class="app-c-checkbox">
					<input type="checkbox" formControlName="notificationOn" />
					<span>Receive Notifications?</span>
				</label>
			</div>

			<div class="app-c-form-group">
				<label class="app-c-form--label" for="orgId" translate>Organization</label>
				<select class="app-c-form-control" id="orgId" formControlName="orgId">
					<option [value]="-1">None</option>
					<option *ngFor="let organization of organizations" [value]="organization.id">{{organization.name}}</option>
				</select>
			</div>

			<div class="app-c-form-group">
				<label class="app-c-form--label" for="timezone">Timezone</label>
				<select class="app-c-form-control" id="timezone" name="timezone" formControlName="timezone">
					<option value="">Select this user's timezone.</option>
					<option *ngFor="let timezone of timezones" [value]="timezone.key">{{timezone.text}}</option>
				</select>
			</div>

			<div class="app-c-form-group">
				<label class="app-c-form--label" for="roleId" translate>Role</label>
				<select class="app-c-form-control" id="roleId" formControlName="roleId">
					<option *ngFor="let role of roles" [value]="role.id">{{role.name}}</option>
				</select>
			</div>

			<div class="form-field">
				<label class="app-c-checkbox">
					<input type="checkbox" formControlName="lockedRole" />
					<span translate>Lock role (useful for sso)</span>
				</label>
			</div>

			<div class="fixed-footer">
				<button
					tabindex="0"
					class="btn-primary btn"
					[ngClass]="{ active: userCreateForm.invalid }"
					[disabled]="userCreateForm.invalid">
					Save
				</button>
			</div>
		</form>
	</div>
  </div>
</div>
